import { Button, ButtonBlock } from '@/src/component/superstack/base/Button';
import { ApiUrls } from '@/data/superstack/ApiUrls';
import LinkTag from '@/src/component/LinkTag';
import ImgReward100 from '@/asset/superstack/svgs/img-reward-100.svg';

export const ApplyLink = ({ mode = 'filled', size = 'xl', job, bubbleStyle = null, ...props }) => {
  const disabled = job.is_applied || !job.is_recruiting;
  const btnName = job.is_applied ? '지원 완료' : '지원하기';
  return (
    <>
      {!disabled && (
        <LinkTag
          isNextPage={true}
          href={ApiUrls(null, job.id).find((url) => url.name === 'job_apply_fe').url}
          style={bubbleStyle ? { position: 'relative' } : {}}
        >
          {bubbleStyle && (
            <span style={bubbleStyle}>
              <ImgReward100 />
            </span>
          )}
          <Button mode={mode} size={size} {...props}>
            {btnName}
          </Button>
        </LinkTag>
      )}
      {disabled && (
        <Button mode={mode} size={size} disabled={disabled} {...props}>
          {btnName}
        </Button>
      )}
    </>
  );
};

export const ApplyLinkBlock = ({ mode = 'filled', size = 'xl', job, ...props }) => {
  const disabled = job.is_applied || !job.is_recruiting;
  const btnName = job.is_applied ? '지원 완료' : '지원하기';
  return (
    <>
      {!disabled && (
        <LinkTag
          isNextPage={true}
          href={ApiUrls(null, job.id).find((url) => url.name === 'job_apply_fe').url}
          {...props}
        >
          <ButtonBlock mode={mode} size={size}>
            {btnName}
          </ButtonBlock>
        </LinkTag>
      )}
      {disabled && (
        <ButtonBlock mode={mode} size={size} disabled={disabled} {...props}>
          {btnName}
        </ButtonBlock>
      )}
    </>
  );
};
